import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: ()=>import('@/pages/Home.vue') 
    },
    {
      path: '/know',
      meta:{menuIndexes:[0,0]},  //菜单位置,[1级，2级]
      component: ()=>import('@/pages/Know.vue') 
    },
    {
      path: '/know/:position',
      meta:{menuIndexes:[0]}, 
      component: ()=>import('@/pages/Know.vue') 
    },
    {
      path: '/join',
      meta:{menuIndexes:[1,0]}, 
      component: ()=>import('@/pages/Join.vue') 
    },
    {
      path: '/join/:position',
      meta:{menuIndexes:[1]},  
      component: ()=>import('@/pages/Join.vue') 
    },
    {
      path: '/in',
      meta:{menuIndexes:[2,0]}, 
      component: ()=>import('@/pages/In.vue') 
    },
    {
      path: '/in/:position',
      meta:{menuIndexes:[2]},  
      component: ()=>import('@/pages/In.vue') 
    }
    // ,
    // {
    //   path: '/teach-in',
    //   meta:{menuIndexes:[3]},  
    //   component: ()=>import('@/pages/TeachIn.vue') 
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js